
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-account/change-password",
      function () {
        return require("private-next-pages/my-account/change-password/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-account/change-password"])
      });
    }
  